import React, { useState, useEffect, useRef } from 'react';
import { fullFillmentList } from 'shared/settings/apiconfig';
import { useHistory } from 'react-router-dom';
import Datatable from 'shared/datatable';
import { capitalizeFirstLetter } from 'shared/utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const FullfillmentList = ({ filter, fullfillmentStatus, saleid, state,irm }) => {
    const history = useHistory();
    const initialSearchState = {
        saleid: { field: "saleid", value: saleid, op: "=", join: "AND" }
    };

    const datatable = useRef(null);
     const customirm = (value) => {
        if (value.fullfillmentirmstatus) {
            const irmStatus = {
                pickup: 'Pickup',
                ship: 'Shipping',
                deliver: 'Delivery',
            };

            return irmStatus[value.fullfillmentirmstatus || '- - -'] || '- - -';
        }
    };
    const customInvoiceNumber = (values) => {
        return (<span style={{ color: "blue", cursor: "pointer" }} onClick={() => invoiceview(values.invoiceid)}>{values['invoicenumber'] ? values['invoicenumber'] : '- - -'}</span>);
    }
    const invoiceview = (invid) => {
        history.push({ pathname: `/invoice/view/${invid}`, state: { name: "Saledashboard", prevPath: `/sales/dashboard/${saleid}`,state } })
    }

    const customeName = (value) => {
          return value.datatransferstatus ? capitalizeFirstLetter(value.datatransferstatus) : '- - -';
    }

    const customShippingLink = (value) => {
        return (value.shippingvendor && (value.shippingvendor).toLowerCase() === 'shipping saint') ? <a style={{ color: 'blue' }} href='https://manage.shippingsaint.com/' target='_blank'>Shipping Saint</a> : value.shippingvendor ? value.shippingvendor : 'Seller';
    }

    const  customShippingStatus = (value) => {
        return value.shipmentstatus && state.saleShippingSaint ? value.shipmentstatus : '- - -';
    }

    const [search, setSearch] = useState({ ...initialSearchState, ...filter });

    useEffect(() => {
        const mergedFilter = { ...initialSearchState, ...filter };
        setSearch(mergedFilter);
    }, [filter]);

    useEffect(() => {
        if (fullfillmentStatus) {
            if (datatable.current) {
                datatable.current.searchData();
            }
        }

    }, [search]);

    const config = {
        name: 'fullfillment',
        url: fullFillmentList,
        params: {},
        columns: [
            { name: 'Data Transfer Status', property: 'datatransferstatus', sort: false, width: '200px',columnType: 'custom', customColumn: customeName  },
            { name: 'Tracking Number', property: 'trackingnumber', sort: false, width: '150px' },
            { name: 'Shipping Vendor', property: 'shippingvendor', sort: false, width: '120px', columnType: 'custom', customColumn: customShippingLink },
            { name: 'Shipping Status', property: 'shipmentstatus', sort: false, width: '120px',columnType: 'custom', customColumn: customShippingStatus },
            { name: 'Carrier', property: 'carrier', sort: false, width: '120px' },
            { name: 'Item Title', property: 'itemtitle', sort: false, width: '200px' },
            { name: 'Invoice Number', property: 'invoicenumber', sort: false, width: '150px',columnType: 'custom', customColumn: customInvoiceNumber },
            { name: 'Email', property: 'buyeremail', sort: false, width: '150px' },
            { name: 'Item Receipt Method', property: 'irm', sort: false, width: '150px', columnType: 'custom', customColumn: customirm }
        ],
        field: ["id", "itemid", "carrier", "trackingnumber","shippingvendor","datatransferstatus", "itemtitle", "irm", "invoicenumber", "invoiceid", "buyeremail", "shipmentstatus", "fullfillmentirmstatus"],
        defaultFilter: [{field: "fullfillmentirmstatus", value: irm, op: "=", join: "AND" }],
        sort: [{ field: 'id', direction: 'desc' }],
        pagination: true,
        ignoreRowBackground: true
    };

   

   

    return (
        <div className="" style={{ width: '100%' }}>
            <Datatable config={{ ...config }} search={{ search: { ...search }, searchData: fullfillmentStatus ?  false : true }} ref={datatable} ></Datatable>
        </div>
    );
};

export default FullfillmentList;
